import {Dropdown, Space, Tooltip} from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import React from "react";

const ThemeSwitcher = () => {
    const { theme, setTheme, themes } = useTheme();

    const items = themes.map(t => ({
        key: t.key,
        label: (
            <Space>
                <div style={{
                    width: 16,
                    height: 16,
                    borderRadius: '50%',
                    background: t.color,
                    border: '1px solid #d9d9d9'
                }} />
                {t.name}
            </Space>
        ),
        onClick: () => setTheme(t.key)
    }));

    const currentTheme = themes.find(t => t.key === theme);

    return (
        <Tooltip title="Switch theme" placement="right">
            <Dropdown menu={{ items }} trigger={['click']}>
                <div onClick={(e) => e.preventDefault()}>
                    {currentTheme?.image || <BgColorsOutlined />}
                </div>
            </Dropdown>
        </Tooltip>

    );
};

export default ThemeSwitcher;

